

















































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { SkillModel } from '@/model/charactersheets';

@Component
export default class Item extends Vue {
  @Prop() public skill!: SkillModel;

  @Emit() public update(skill: SkillModel) {}
  @Emit() public delete() {}

  private get value() {
    return this.skill;
  }

  public deleteSkill() {
    this.delete();
  }
  public updateValue(skill: SkillModel) {
    skill.totalpoint = skill.jobpoint + skill.interestpoint + skill.initial + skill.otherpoint;
    this.update(skill);
  }
}
